import { CSSProperties, FunctionComponent, HTMLAttributes, ReactNode } from 'react';
import cn from '../cn';

// --- List ---
type ListProps = { dense?: boolean; children?: ReactNode } & HTMLAttributes<HTMLUListElement>;
export const List: FunctionComponent<ListProps> = ({ dense = false, className = '', children, ...rest }) => (
  <ul className={cn('m-0 list-none p-0', dense ? 'py-1' : 'py-2', className)} {...rest}>{children}</ul>
);

// --- ListItem ---
type ListItemProps = { disableGutters?: boolean; dense?: boolean; children?: ReactNode } & HTMLAttributes<HTMLLIElement>;
export const ListItem: FunctionComponent<ListItemProps> = ({ disableGutters = false, dense = false, className = '', children, ...rest }) => (
  <li className={cn('flex items-center gap-4', disableGutters ? 'px-0' : 'px-4', dense ? 'py-1' : 'py-2', className)} {...rest}>{children}</li>
);

// --- ListItemAvatar ---
type ListItemAvatarProps = { children?: ReactNode } & HTMLAttributes<HTMLDivElement>;
export const ListItemAvatar: FunctionComponent<ListItemAvatarProps> = ({ className = '', children, ...rest }) => (
  <div className={cn('min-w-[56px] shrink-0', className)} {...rest}>{children}</div>
);

// --- ListItemText ---
type TypographyProps = { fontSize?: string | number; fontWeight?: string | number };
type ListItemTextProps = {
  primary?: ReactNode,
  secondary?: ReactNode,
  primaryTypographyProps?: TypographyProps,
  secondaryTypographyProps?: TypographyProps,
  children?: ReactNode,
} & HTMLAttributes<HTMLDivElement>;
export const ListItemText: FunctionComponent<ListItemTextProps> = ({
  primary, secondary, primaryTypographyProps, secondaryTypographyProps, className = '', style, children, ...rest
}) => (
  <div className={cn('min-w-0 flex-1', className)} style={style} {...rest}>
    <div style={primaryTypographyProps as CSSProperties} className={primaryTypographyProps ? undefined : 'text-base'}>
      {primary ?? children}
    </div>
    {secondary !== undefined && (
      <div style={secondaryTypographyProps as CSSProperties} className={secondaryTypographyProps ? 'text-black/60' : 'text-sm text-black/60'}>
        {secondary}
      </div>
    )}
  </div>
);
